import BladderReportTemplate from './BladderReportTemplate';
import GenericReportTemplate from './GenericReportTemplate';
import ProstateReportTemplate from './ProstateReportTemplate';
import {
  buildBladderReportText,
  buildGenericReportText,
  buildProstateReportText,
  createBladderReport,
  createGenericReport,
  createProstateReport
} from './reportTemplateText';

export const reportTemplates = [
  {
    value: 'general',
    labelKey: 'general-disease-template',
    noteKey: 'general-template-note',
    component: GenericReportTemplate,
    createReport: createGenericReport,
    buildReportText: buildGenericReportText
  },
  {
    value: 'prostate',
    labelKey: 'prostate',
    noteKey: 'prostate-shared-template-note',
    component: ProstateReportTemplate,
    createReport: createProstateReport,
    buildReportText: buildProstateReportText
  },
  {
    value: 'bladder',
    labelKey: 'bladder',
    noteKey: 'bladder-proforma-template-note',
    component: BladderReportTemplate,
    createReport: createBladderReport,
    buildReportText: buildBladderReportText
  }
];

export function findReportTemplate(value) {
  return reportTemplates.find(template => template.value === value) || reportTemplates[0];
}
